
   <div a-context-menu-legasy class="no_overlay" *ngIf="isMenuVisible"
       (click)="doClose()"
       [ngClass]="{'slim': menuSlim, 'right': menuRight, 'top': menuTop}"
    >
      <ng-content></ng-content>
    </div>
    <div class="overlay" *ngIf="isMenuVisible && !noOverlay"></div>
  